import axios from 'axios'
import { useAuthHeader } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import Spinner from '../usables/small/Spinner'
import ClosingAlert from '../usables/Alert'
import SmallCard from '../usables/small/SmallCard'

export default function Dashboard() { 
  const auth  = useAuthHeader()
  const [dash, setDash] = useState({})
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})

  const config = {
    headers: {
      Authorization: auth()
    }
  }
  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/msc/dash', config)
    .then(res => {
      if(res.status === 200){
        setDash(res.data[0])
        setDataLoaded({done: true, sucssess: true, items: res.data.length})
      }
    })    
    .catch(err => {
      setDash([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setDash(err.response.data)
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    <h2>Prietaisų skydelis</h2>
    {!dataLoaded.done
    ? <Spinner />
    : dataLoaded.sucssess
      ?dataLoaded.items
        ? <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 p-4 mb-[10rem]">
            <SmallCard number={dash.users} text='Vartotojai' />
            <SmallCard number={dash.students} text='Mokiniai' />
            <SmallCard number={dash.teachers} text='Mokytojai' />
            <SmallCard number={dash.guardians} text='Globėjai' />
            <SmallCard number={dash.classes} text='Klasės' />
            <SmallCard number={dash.classrooms} text='Kabinetai' />
            <SmallCard number={dash.people} text='Viso asmenų' />
          </div>
        : <ClosingAlert type='warning' message='Nerastas jokia informacija' />
      : <ClosingAlert type='error' message='Nepavyko gauti informacijos bandykite vėl šiek tiek vėliau' />
    }
    </>
  )
}